import React from 'react';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { EnquiryForm } from '../components/forms/EnquiryForm';

const offices = [
  {
    city: 'Zurich',
    address: 'Limmatquai 112',
    postcode: '8001 Zürich',
    phone: '+41 44 250 88 88',
    email: 'zurich@recrutement-suisse.ch',
    hours: 'Lun - Ven: 8h30 - 18h00',
    image: 'https://images.unsplash.com/photo-1573649647330-b3a1375227fe?w=800&q=80',
    description: 'Notre siège principal au c\u0153ur de Zurich, idéalement situé près de la gare centrale.'
  },
  {
    city: 'Genève',
    address: 'Rue du Rhône 118',
    postcode: '1204 Genève',
    phone: '+41 22 318 88 88',
    email: 'geneve@recrutement-suisse.ch',
    hours: 'Lun - Ven: 8h30 - 18h00',
    image: 'https://images.unsplash.com/photo-1573164574511-73c773193279?w=800&q=80',
    description: 'Notre bureau genevois au centre de la cité internationale, proche des organisations internationales.'
  },
  {
    city: 'Lausanne',
    address: 'Place de la Gare 4',
    postcode: '1003 Lausanne',
    phone: '+41 21 341 88 88',
    email: 'lausanne@recrutement-suisse.ch',
    hours: 'Lun - Ven: 8h30 - 18h00',
    image: 'https://images.unsplash.com/photo-1664464683525-29b5d442af54?w=800&q=80',
    description: 'Notre bureau lausannois au c\u0153ur de la capitale vaudoise, face à la gare.'
  }
];

const BureauxPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero */}
      <section className="bg-[#E30022] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-serif mb-4">Nos bureaux</h1>
          <p className="text-xl opacity-90">Rencontrez nos équipes dans toute la Suisse</p>
        </div>
      </section>

      {/* Offices */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="space-y-12">
          {offices.map((office, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="grid lg:grid-cols-2">
                <ResponsiveImage sizes="(min-width: 1280px) 600px, (min-width: 1024px) 50vw, 100vw"
                  src={office.image}
                  alt={office.city}
                  className="h-64 lg:h-full w-full object-cover"
                />
                <div className="p-5 sm:p-8 lg:p-12 min-w-0">
                  <h2 className="text-3xl font-serif text-gray-800 mb-4">{office.city}</h2>
                  <p className="text-gray-600 mb-6">{office.description}</p>
                  
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <MapPin className="h-5 w-5 text-[#E30022] flex-shrink-0 mt-1" />
                      <div>
                        <p className="text-gray-800 font-medium">{office.address}</p>
                        <p className="text-gray-600">{office.postcode}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <Phone className="h-5 w-5 text-[#E30022]" />
                      <p className="text-gray-800">{office.phone}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <Mail className="h-5 w-5 text-[#E30022] shrink-0" />
                      <p data-testid={`office-${index}-email`} className="text-gray-800 break-all min-w-0">{office.email}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <Clock className="h-5 w-5 text-[#E30022]" />
                      <p className="text-gray-600">{office.hours}</p>
                    </div>
                  </div>

                  <button className="mt-6 bg-[#E30022] text-white px-6 py-3 rounded hover:bg-[#c7001d] transition-colors font-medium">
                    Voir sur Google Maps
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Form */}
      <section className="bg-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-serif text-gray-800 mb-4 text-center">Contactez-nous</h2>
          <p className="text-gray-600 text-center mb-12">Une question ? N'hésitez pas à nous contacter.</p>
          
          <EnquiryForm kind="contact" />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BureauxPage;
